import { ComponentType as y } from "../../registries/types/propTypes.js";
const d = (e) => {
  const t = Array.isArray(e == null ? void 0 : e.grid_view_image_gallery) ? e.grid_view_image_gallery[0] : e == null ? void 0 : e.grid_view_image_gallery, { images: i = [], grid_view_layout: l } = t || {}, g = (m) => m.map((n) => {
    const { url: r, target: _, image: a } = n;
    return {
      src: (a == null ? void 0 : a.url) || "",
      alt: (a == null ? void 0 : a.title) || "",
      ctaConfig: r ? {
        href: r,
        target: _
      } : void 0
    };
  });
  return {
    componentType: y.grid_view_image_gallery,
    images: g(i),
    imagesPerRow: l || 1
  };
};
export {
  d as default
};
//# sourceMappingURL=grid-view-image-gallery-transformer.js.map
